import { FileText } from "lucide-react";
import CrudManager, { slugify } from "@/components/admin/CrudManager";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import ImageUpload from "@/components/admin/ImageUpload";
import { ADMIN } from "@/constants/testIds";

const DEFAULT = { title: "", slug: "", excerpt: "", content: "", cover_image: "", tags: [], author: "Hermanos Team", published: true };

export default function AdminBlogs() {
  return (
    <CrudManager
      title="Blogs"
      subtitle="Publish business insights, wholesale trends, retailer guides."
      endpoint="/admin/blogs"
      defaultItem={DEFAULT}
      testId={ADMIN.blogsList}
      searchKeys={["title", "author"]}
      listRender={(b) => (
        <div className="flex items-center gap-4">
          <div className="h-14 w-20 rounded-sm bg-secondary overflow-hidden shrink-0">
            {b.cover_image ? <img src={b.cover_image} alt={b.title} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-foreground/40"><FileText size={16} /></div>}
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-[0.65rem] tracking-widest uppercase text-gold">{b.author}</p>
            <p className="mt-0.5 font-serif text-lg text-foreground truncate">{b.title}</p>
            <p className="text-xs text-foreground/60 truncate">{b.excerpt}</p>
          </div>
        </div>
      )}
      formRenderer={(v, patch) => (
        <>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <Label>Title</Label>
              <Input className="mt-2 rounded-sm" value={v.title} onChange={(e) => patch({ title: e.target.value, slug: v.slug || slugify(e.target.value) })} />
            </div>
            <div>
              <Label>Slug</Label>
              <Input className="mt-2 rounded-sm" value={v.slug} onChange={(e) => patch({ slug: slugify(e.target.value) })} />
            </div>
          </div>
          <div>
            <Label>Excerpt (summary shown on listing)</Label>
            <Textarea className="mt-2 rounded-sm" value={v.excerpt} onChange={(e) => patch({ excerpt: e.target.value })} />
          </div>
          <div>
            <Label>Content (Markdown-lite: **bold**, blank line for paragraph, - for list)</Label>
            <Textarea className="mt-2 rounded-sm font-mono text-sm min-h-[220px]" value={v.content} onChange={(e) => patch({ content: e.target.value })} />
          </div>
          <ImageUpload label="Cover Image" value={v.cover_image} onChange={(u) => patch({ cover_image: u })} />
          <div className="grid md:grid-cols-3 gap-4 items-end">
            <div>
              <Label>Author</Label>
              <Input className="mt-2 rounded-sm" value={v.author} onChange={(e) => patch({ author: e.target.value })} />
            </div>
            <div>
              <Label>Tags (comma separated)</Label>
              <Input className="mt-2 rounded-sm" value={(v.tags || []).join(", ")} onChange={(e) => patch({ tags: e.target.value.split(",").map((s) => s.trim()).filter(Boolean) })} />
            </div>
            <label className="flex items-center gap-3 p-3 rounded-sm border border-border/60 bg-secondary/40 cursor-pointer">
              <Switch checked={v.published} onCheckedChange={(c) => patch({ published: c })} />
              <span className="text-sm">Published</span>
            </label>
          </div>
        </>
      )}
    />
  );
}
